import Organisation from '@/models/Organisation';
import OrganisationType from '@/models/OrganisationType';
import User from '@/models/User';
import { Currency } from '@/modules/fund/types';

export interface IDashboardState {
  organisations: Organisation[];
  organisationTypes: OrganisationType[];
  superAccessRoles: string[];
  currentUser: User | null;
  currencies: Currency[];
}

export const DashboardState: IDashboardState = {
  organisations: [],
  organisationTypes: [],
  superAccessRoles: [],
  currentUser: null,
  currencies: []
};
